import { NumRange } from '../../types/types';

// eslint-disable-next-line import/prefer-default-export
export const DAYS_RETENTION_RANGE: NumRange = {
    min: 1,
    max: 365,
};
